@app.directive 'bannerInline', ->
  restrict: 'E'
  scope: {}
  controllerAs: 'bannerInline'
  controller: ->


    this

  link: (scope, element, attrs) ->

  bindToController: {
    theme: '='
    content: '='
  }
  templateUrl: "/assets/templates/components/banner/bannerInline/bannerInline.html"
